/* eslint-disable max-classes-per-file */
/* eslint-disable import/prefer-default-export */
export class YouCantBeHereError extends Error {
  name = 'YouCantBeHereError';
}

export class IssueStepNotSpecified extends Error {
  name = 'IssueStepNotSpecified';
}

export class RouteError extends Error {
  name = 'RouteError';
}
